import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "esports_valorant_bd4e4",
  "use": "esports_valorant_bd4e4-usage",
  "viewBox": "0 0 300 247",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 300 247\" id=\"esports_valorant_bd4e4\">\n    <path d=\"M300 118.56V1.996c0-1.798-2.247-2.547-3.446-1.199L169.203 159.911c-1.049 1.199-.15 3.147 1.498 3.147h91.993c2.547 0 4.794-1.199 6.292-3.147l29.066-36.257A7.683 7.683 0 0 0 300 118.56zM2.148 123.804l95.588 119.56c1.498 1.948 3.896 2.997 6.443 2.997h91.992c1.648 0 2.547-1.798 1.498-2.997L3.646.947C2.447-.401.2.347.2 2.146V118.71c.15 1.797.75 3.595 1.948 5.094z\" fill=\"#FF4655\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol